var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.539,
    height: 44.957,
    viewBox: "0 0 211.539 44.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,25.4V.01H7.1a11.975,11.975,0,0,1,4.79.94,11.106,11.106,0,0,1,3.758,2.635,12.123,12.123,0,0,1,2.453,3.987,14.124,14.124,0,0,1,.87,5.042,14.846,14.846,0,0,1-.917,5.363,11.571,11.571,0,0,1-2.545,4.034,10.969,10.969,0,0,1-3.826,2.52,12.943,12.943,0,0,1-4.813.872ZM3.758,3.768V21.645h2.52a9.109,9.109,0,0,0,3.53-.666,8.394,8.394,0,0,0,4.653-4.711,9.533,9.533,0,0,0,.665-3.584,9.661,9.661,0,0,0-.665-3.63A8.206,8.206,0,0,0,12.6,6.227a8.4,8.4,0,0,0-2.8-1.815,9.389,9.389,0,0,0-3.53-.644Z",
    transform: "translate(0 -0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.949.01H39.47V3.768H29.708v6.739h6.1v3.757h-6.1v7.38H39.47V25.4H25.949Z",
    transform: "translate(-3.078 -0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.995,25.4H51.778V3.768H45.086V.01H62.6V3.768h-6.6Z",
    transform: "translate(-5.347 -0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.108,15.41H72.661V25.4H68.9V.009h8.939A7.492,7.492,0,0,1,83.57,1.934a7.754,7.754,0,0,1,2.2,5.776,7.3,7.3,0,0,1-2.2,5.73,6.4,6.4,0,0,1-2.612,1.512l4.9,10.451H81.829ZM72.661,3.767v7.884h5.454q3.805,0,3.9-3.8-.091-4.079-3.9-4.08Z",
    transform: "translate(-8.172 0)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.772.01h13.521V3.768H96.53v6.739h6.1v3.757h-6.1v7.38h9.764V25.4H92.772Z",
    transform: "translate(-11.002 -0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.177,6.885,123.623,25.4,116.656,6.84V25.4H112.9V.01h5.179l5.547,15.356L129.077.01h4.859V25.4h-3.759Z",
    transform: "translate(-13.389 -0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.09,6.885,152.535,25.4,145.569,6.84V25.4H141.81V.01h5.179l5.545,15.356L157.99.01h4.859V25.4H159.09Z",
    transform: "translate(-16.818 -0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.723.01h13.521V3.768h-9.762v6.739h6.1v3.757h-6.1v7.38h9.762V25.4H170.723Z",
    transform: "translate(-20.247 -0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.052,15.41h-4.445V25.4h-3.758V.009h8.937a7.5,7.5,0,0,1,5.73,1.925,7.761,7.761,0,0,1,2.2,5.776,7.3,7.3,0,0,1-2.2,5.73,6.4,6.4,0,0,1-2.612,1.512l4.9,10.451h-4.033ZM194.607,3.767v7.884h5.455q3.805,0,3.9-3.8-.093-4.079-3.9-4.08Z",
    transform: "translate(-22.634 0)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.759,
    height: 25.393,
    transform: "translate(189.253 0.008)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.129.01h13.522V3.768h-9.762v6.739h6.1v3.757h-6.1v7.38h9.762V25.4H224.129Z",
    transform: "translate(-26.581 -0.001)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.088,49.675V41.514h4.56v.866h-3.4v2.736H136.1v.854h-2.858v3.705Z",
    transform: "translate(-15.665 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93,41.514h1.157v5.15a2.837,2.837,0,0,0,.456,1.789,1.758,1.758,0,0,0,1.447.561,1.634,1.634,0,0,0,1.376-.527,2.993,2.993,0,0,0,.405-1.784V41.514h1.015v5.173a3.561,3.561,0,0,1-.687,2.431,2.807,2.807,0,0,1-2.187.762,2.932,2.932,0,0,1-2.255-.788,3.5,3.5,0,0,1-.728-2.438Z",
    transform: "translate(-17.07 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.931,49.676V41.514h2.47a2.756,2.756,0,0,1,1.8.518,1.845,1.845,0,0,1,.626,1.505,2.372,2.372,0,0,1-1.649,2.317l2.725,3.821H162.48l-2.321-3.452h-1.081v3.452Zm1.147-4.318h.375q2.184,0,2.184-1.715,0-1.261-1.831-1.262h-.728Z",
    transform: "translate(-18.73 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.081,49.675V41.514h1.136l4.108,6.3v-6.3h.992v8.161h-1.131l-4.113-6.3v6.3Z",
    transform: "translate(-20.289 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.159,
    height: 8.161,
    transform: "translate(163.577 36.591)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.146,49.675v-7.3h-2.9v-.866H200.2v.866H197.3v7.3Z",
    transform: "translate(-22.919 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.408,41.514h1.157v5.15a2.826,2.826,0,0,0,.456,1.789,1.753,1.753,0,0,0,1.446.561,1.637,1.637,0,0,0,1.377-.527,2.993,2.993,0,0,0,.405-1.784V41.514h1.014v5.173a3.571,3.571,0,0,1-.686,2.431,2.81,2.81,0,0,1-2.187.762,2.932,2.932,0,0,1-2.255-.788,3.5,3.5,0,0,1-.728-2.438Z",
    transform: "translate(-24.598 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.408,49.676V41.514h2.471a2.757,2.757,0,0,1,1.8.518,1.844,1.844,0,0,1,.626,1.505,2.372,2.372,0,0,1-1.649,2.317l2.724,3.821h-1.423l-2.321-3.452h-1.081v3.452Zm1.148-4.318h.375q2.184,0,2.184-1.715,0-1.261-1.832-1.262h-.727Z",
    transform: "translate(-26.258 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.558,49.675V41.514h4.56v.866h-3.4V45h2.851v.856h-2.851v2.955h3.64v.866Z",
    transform: "translate(-27.818 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.004 30.418)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 211.079,
    height: 0.441,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.007,49.676V41.514H2.123A3.218,3.218,0,0,1,4,41.978a1.537,1.537,0,0,1,.652,1.334,2.193,2.193,0,0,1-1.675,2.112q2,.612,2,2.211a1.819,1.819,0,0,1-.662,1.516,3.014,3.014,0,0,1-1.907.524ZM1.154,45.1h.369a2.29,2.29,0,0,0,1.436-.4,1.335,1.335,0,0,0,.51-1.119q0-1.2-1.864-1.2H1.154Zm0,3.711H1.39a5.211,5.211,0,0,0,1.648-.16,1.117,1.117,0,0,0,.717-1.125,1.453,1.453,0,0,0-.65-1.211,2.66,2.66,0,0,0-1.626-.482H1.154Z",
    transform: "translate(-0.001 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.655,49.675l-.888-2.261H13.31l-.9,2.261H11.336l3.237-8.16H15.72l3.187,8.16Zm-1.224-3.121-1.389-3.518-1.4,3.518Z",
    transform: "translate(-1.345 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125,49.675v-7.3h-2.9v-.866h6.949v.866h-2.9v7.3Z",
    transform: "translate(-2.992 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.462,49.675V41.514H40.62v3.441H44.5V41.514H45.66v8.161H44.5V45.821H40.62v3.854Z",
    transform: "translate(-4.68 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.926,49.676V41.514H56.4a2.754,2.754,0,0,1,1.8.518,1.842,1.842,0,0,1,.626,1.505,2.37,2.37,0,0,1-1.648,2.317L59.9,49.676H58.475l-2.323-3.452h-1.08v3.452Zm1.147-4.318h.375q2.184,0,2.184-1.715,0-1.261-1.831-1.262h-.728Z",
    transform: "translate(-6.395 -4.923)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3,49.853a3.463,3.463,0,0,1-2.732-1.178,5.192,5.192,0,0,1,.005-6.225,3.887,3.887,0,0,1,5.551,0,4.482,4.482,0,0,1,1.041,3.1,4.533,4.533,0,0,1-1.041,3.14A3.61,3.61,0,0,1,70.3,49.853m.017-.866a2.286,2.286,0,0,0,1.936-.9,4.135,4.135,0,0,0,.683-2.544,4.028,4.028,0,0,0-.686-2.493,2.459,2.459,0,0,0-3.8,0,4.063,4.063,0,0,0-.685,2.506,4.142,4.142,0,0,0,.68,2.515,2.2,2.2,0,0,0,1.875.916",
    transform: "translate(-7.89 -4.896)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3,49.853a3.458,3.458,0,0,1-2.731-1.178,5.185,5.185,0,0,1,.005-6.225,3.885,3.885,0,0,1,5.549,0,4.474,4.474,0,0,1,1.042,3.1,4.525,4.525,0,0,1-1.042,3.14A3.607,3.607,0,0,1,85.3,49.853m.017-.866a2.283,2.283,0,0,0,1.935-.9,4.135,4.135,0,0,0,.684-2.544,4.016,4.016,0,0,0-.687-2.493,2.458,2.458,0,0,0-3.8,0,4.063,4.063,0,0,0-.684,2.506,4.136,4.136,0,0,0,.679,2.515,2.2,2.2,0,0,0,1.875.916",
    transform: "translate(-9.669 -4.896)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.078,49.675V41.514h1.6l2.261,6.315,2.326-6.315H104.7v8.161h-1.081V43.036l-2.249,6.093h-1.119l-2.184-6.11v6.656Z",
    transform: "translate(-11.513 -4.923)",
    fill: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.d5efc51ad280ed2f96fad3084a9e16d0.svg";
export { ForwardRef as ReactComponent };